module.exports = __webpack_public_path__ + "img/Familia.971a43ae.svg";